import React, { useEffect, useRef, useState } from 'react';
import './InicioComponent.css';
import FooterComponent from '../Footer/FooterComponent';
import HeaderComponent from '../Header/HeaderComponent';
import LivePlayer from '../vimeo/LiveVimeoPlayerComponent';
import { getEventActually } from '../../services/EventServices';
import { useLocation } from 'react-router-dom';
import { io } from 'socket.io-client';
import { ModalQuestions } from '../Modal/ModalComponent';
import StatusEventServices from '../../services/StatusEventServices';
import UserStatsLayout from '../EventStadistics/EventStadisticsComponent';
import GetStaff from '../../services/GetStaffServices';

const InicioComponent = () => {
  const location = useLocation();
  const [dataEvent, setDataEvent] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [statusEventData, setStatusEventData] = useState([]);
  const name = sessionStorage.getItem('name');
  const lastName = sessionStorage.getItem('last_name');

  const fullName = `${name} ${lastName}`;

  const socketRef = useRef(null); // Usar useRef para almacenar la conexión

  const openModalHandler = () => {
    setOpenModal(true);
  };

  const closeModalHandler = () => {
    setOpenModal(false);
  };

  const token = sessionStorage.getItem('token');

  useEffect(() => {
    if (!socketRef.current) {
      socketRef.current = io('https://innovadorsocket.interactiva.net.co');

      socketRef.current.on('connect', () => {
        console.log('Socket conectado:', socketRef.current.id);

        if (location.pathname === '/inicio') {
          socketRef.current.emit('join_page', { page: '/inicio' });
        }

        if (location.pathname === '/chatLive') {
          socketRef.current.emit('join_page', { page: '/inicio' });
        }
      });

      // Escuchar eventos
      socketRef.current.on('show_modal', () => {
        openModalHandler();
      });

      socketRef.current.on('close_modal', () => {
        closeModalHandler();
      });

      // Cleanup
      return () => {
        if (location.pathname === '/inicio') {
          socketRef.current.emit('leave_page', { page: '/inicio' });
        }

        if (location.pathname === '/chatLive') {
          socketRef.current.emit('leave_page', { page: '/inicio' });
        }

        socketRef.current.disconnect();
        socketRef.current = null;
      };
    }
  }, [location.pathname]);

  useEffect(() => {
    // Función para obtener los datos del evento
    const getData = async () => {
      try {
        const response = await getEventActually();
        setDataEvent(response.events);

        // Si hay eventos y showPopup es true, emitimos el evento para mostrar el modal
        if (response.events.length > 0 && response.events[0].showPopup) {
          if (location.pathname === '/inicio') {
            socketRef.current.emit('trigger_modal');
          }
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    // Llamamos a getData una vez cuando el componente se monta
    getData();
  }, []); // La dependencia vacía asegura que esto se ejecute solo una vez

  useEffect(() => {
    const getStatus = async () => {
      try {
        const response = await StatusEventServices(token);
        setStatusEventData(Array(response));
        console.log(response)
      } catch (error) {
        console.error(error);
      }
    };

    getStatus(); // Llama a la función la primera vez al montar el componente

    // Configura el intervalo para hacer la solicitud cada 30 segundos
    const intervalId = setInterval(getStatus, 30000); // 30000 ms = 30 segundos

    // Limpia el intervalo cuando el componente se desmonte o cuando el token cambie
    return () => clearInterval(intervalId);
  }, [token]); // Dependencia de token

  useEffect(() => {
    const getStaffs = async () => {
      try {
        const response = await GetStaff(token);

        // Suponemos que el email está guardado en sessionStorage con la clave "email"
        const storedEmail = sessionStorage.getItem("email");

        if (response.emails.includes(storedEmail)) {
          setIsAdmin(true)
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error("Error al obtener los staffs:", error);
      }
    };

    getStaffs();
  }, [token]);




  return (
    <>
      <div className="container-innovador min-h-screen flex flex-col">
        <HeaderComponent />
        {dataEvent.map((data, index) => (
          <div key={index} className="flex-grow flex flex-col items-center p-3">
            <div className="bg-gray-600 w-full md:w-4/5 flex-grow mb-4 p-4">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 h-full">
                <div className="col-span-2 md:col-span-3 p-4 h-full">
                  <LivePlayer urlStreaming={data.url_streaming} className="h-full w-full" />


                  {isAdmin && (
                    <div className="container mx-auto">
                      <UserStatsLayout key={index} totalUsers={statusEventData[0]?.data['registered_to_current_event']} activeUsers={statusEventData[0]?.data['last_login_october_5']} socketRef={socketRef} />
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="relative w-full md:w-3/4 lg:w-1/2 mb-1">
              <iframe
                src={`https://e.interactiva.com.co/#/${data.url_chat}?name=Dr/a.${encodeURIComponent(fullName)}`}
                title="Interactive Content"
                className="relative w-full"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        ))}

        <FooterComponent />
        <ModalQuestions showModal={openModal} closeModal={closeModalHandler} />
      </div>
    </>
  );
};

export default InicioComponent;
